import { Component, OnInit } from '@angular/core';
import { InitialSourceEnum } from '../services/tracking.service';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
    readonly homepage = 'https://developerakademie.com';
    redirectUrl = '';
    initialSource = InitialSourceEnum.Facebook;
    currentPath = '';

    /**
     * Checks if the current path ends with any of the provided suffixes.
     *
     * @param {...string[]} suffixes - The list of suffixes to check against the current path.
     * @returns {boolean} True if the current path ends with at least one of the provided suffixes, otherwise false.
     */
    private pathEndsWith(...suffixes: string[]): boolean {
        return suffixes.some((suffix) => this.currentPath.endsWith(suffix));
    }

    /**
     * Extracts the pathname from the current window location.
     * Used to determine the initialSource and redirect behavior.
     */
    private setCurrentPath() {
        const CURRENT_HREF = window.location.href;
        const CURRENT_URL = new URL(CURRENT_HREF);
        this.currentPath = CURRENT_URL.pathname;
    }

    /**
     * Sets the initialSource based on the currentPath.
     */
    private setInitialSource() {
        if (this.pathEndsWith('/g', '/g/', '/info', '/info/')) {
            this.initialSource = InitialSourceEnum.Google;
        } else if (this.pathEndsWith('/y', '/y/')) {
            this.initialSource = InitialSourceEnum.Youtube;
        } else if (this.pathEndsWith('/ya', '/ya/')) {
            this.initialSource = InitialSourceEnum.YoutubeAds;
        } else if (this.pathEndsWith('/t', '/t/')) {
            this.initialSource = InitialSourceEnum.Unknown;
        }
    }

    /**
     * Sets the redirectUrl based on the currentPath.
     * For known paths, builds clean UTM tracking manually.
     * For unknown paths, preserves existing query params and appends initialSource.
     */
    private setRedirectUrl() {
        if (this.pathEndsWith('/tt2yt', '/tt2yt/')) {
            this.redirectUrl = 'https://www.youtube.com/Programmierenlernen';
            return;
        }

        const PARAMS = new URLSearchParams();

        if (this.pathEndsWith('/y', '/y/')) {
            PARAMS.set('utm_source', 'youtube');
            PARAMS.set('utm_medium', 'video');
            PARAMS.set('utm_campaign', 'yt_video');
            PARAMS.set('utm_id', 'regular_video');
            PARAMS.set('utm_content', 'yt_description');
        } else if (this.pathEndsWith('/ya', '/ya/')) {
            PARAMS.set('utm_source', 'youtube');
            PARAMS.set('utm_medium', 'video');
            PARAMS.set('utm_campaign', 'yt_ad');
            PARAMS.set('utm_id', 'paid_video');
            PARAMS.set('utm_content', 'yt_ad_clicked');
        } else if (this.pathEndsWith('/t', '/t/')) {
            PARAMS.set('utm_source', 'tiktok');
            PARAMS.set('utm_medium', 'profile');
            PARAMS.set('utm_campaign', 'tiktok');
            PARAMS.set('utm_id', 'tiktok_video');
            PARAMS.set('utm_content', 'tiktok_profile');
        } else {
            // Fallback: keep original query string and append initialSource
            const EXISTING_PARAMS = new URLSearchParams(window.location.search);
            EXISTING_PARAMS.set('initialSource', this.initialSource);
            this.redirectUrl = `${this.homepage}?${EXISTING_PARAMS.toString()}`;
            return;
        }

        // For known paths: append initialSource only, no original query
        PARAMS.set('initialSource', this.initialSource);
        this.redirectUrl = `${this.homepage}?${PARAMS.toString()}`;
    }

    ngOnInit(): void {
        this.setCurrentPath();
        this.setInitialSource();
        this.setRedirectUrl();
        // console.log(this.redirectUrl);
        window.location.href = this.redirectUrl;
    }
}
